import http from '@/communication/AuthConnection'

/**
* Read the file dropped
*/
const readFile = (pFile) => {
  const formData = new FormData()
  formData.append('fileCSV', pFile)
  return http
    .post('/v1/cmed/upload', formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
}

export default readFile



// WEBPACK FOOTER //
// ./src/view/record/cmed/components/new-cmed/form-file-input/FileHandle.js